import {
  checkoutStepsGA,
  customerGA,
  customerHeap,
  bounceXPixel,
} from '@/helpers'

import { Configuration, Product, HeapAnalytics } from '@/services'


const { LISTRAK_ID } = Configuration

import { log } from '../Log'

/**
* Reports a user event to the event stream.
*
* @param {string} email - email address
* @param {string} inputFieldId - id attribute of email input
*/
const pushWKNDUserEvent = (email, inputFieldId) => {
  window.bouncex = window.bouncex || [];
  window.bouncex.push(['user', {
      email,
      source: 'input_submission',
      input_id : inputFieldId
  }])
}

export const gaCheckoutEvents = async ({ step, lineItems }) => { checkoutStepsGA(step, lineItems , 'checkout') }

export const gaCustomer = async ({ grandTotal, pageType }) => customerGA(grandTotal, pageType)

export const heapCustomer = async ({ grandTotal, pageType }) => customerHeap(grandTotal, pageType)

export const gaTrackFields = async ({
  eventCategory, eventAction, eventLabel, eventValue, fieldsObject,
}) => {
  if (window.ga) {
    const tracker = window.ga.getAll()[0]
    if (tracker) {
      tracker.send('event', eventCategory, eventAction, eventLabel, eventValue, fieldsObject)
    }
  }
}

export const gaUserStatus = async ({ userStatus }) => window.gatag && window.gatag('event', 'userLoginStatus', { user_login_status: userStatus })

export const bounceXPixelTracking = async ({
  order, lineItems, itemsSubtotal, shippingCost, taxTotal, grandTotal,
}) => {
  order.billingAddress = {...order.billingAddress, email: order?.email}
  bounceXPixel(order, lineItems, itemsSubtotal, shippingCost, taxTotal, grandTotal)
}

// TODO: This should be an env_var
export const emailOptIn = async ({ email, optedIn }) => {
  const listrakList = 'BCGuestCheckout'
  try {
    const subscriptionStatus = optedIn ? 'on' : 'off'
    const emailAddress = encodeURIComponent(email)
    const url = `https://s1.listrakbi.com/t/S.ashx?ctid=${LISTRAK_ID}&_t_0=s&e_0=${emailAddress}&l_0=${listrakList}&ltkChannel_0=email&ltkOptIn_0=${subscriptionStatus}&ltkSource_0=on`

    fetch(url, { method: 'GET', mode: 'no-cors' })
  } catch (e) {
    log(e)
  }
}

export const recordAbandonedCartEmail = ({ email, inputFieldId }) => {
  try {
    pushWKNDUserEvent(email, inputFieldId)
  } catch (e) {
    log(e)
  }
}

export const getExperiment = async (experimentId, DEFAULT_CHECKOUT_VARIANT = 0) => new Promise((resolve) => {
  let loadingAttempts = 0
  const retryInterval = setInterval(() => {
    const variant = window?.google_optimize?.get(experimentId)
    if (variant) { // Script loaded
      clearInterval(retryInterval)
      resolve({ variant, success: true })
    } else if (loadingAttempts++ > 10) { // 1s trying to load the script which should load in less than 300ms
      clearInterval(retryInterval)
      resolve({ variant: DEFAULT_CHECKOUT_VARIANT, success: false })
    }
  }, 100)
})

export const heapOrderTracking = async ({ order, lineItems }) => {
  const lineItemsWithCategories = await Promise.all(
    lineItems.map(async (lineItem) => {
      const product = await Product.bySku({ sku: lineItem.sku })
      return { ...lineItem, categories: product?.categories }
    }),
  )
  HeapAnalytics.trackOrder({ order, lineItems: lineItemsWithCategories })
}

export const heapPurchaseTracking = async ({ order, lineItems }) => {
  const lineItemsWithCategories = await Promise.all(
    lineItems.map(async (lineItem) => {
      const product = await Product.bySku({ sku: lineItem.sku })
      return { ...lineItem, categories: product?.categories }
    }),
  )
  HeapAnalytics.trackPurchase({ order, lineItems: lineItemsWithCategories })
}




export const getCitizensPayReferenceId = async () => {
  // this will not work because it's not init'd with the product/variant
  // const referenceId = window?.OfferByPrice?.getReferenceId()
  try {
    const referenceIdKey = Object.keys(window?.localStorage)
      .find(key => key.indexOf('referenceId') >= 0)
    const referenceId = window?.localStorage?.getItem(referenceIdKey) || undefined
    return referenceId
  } catch (e) {
    log('No referenceId found')
  }
}

export const listrakEmailCapture = (email) => {
  try {
    if (email && _ltk) {
      _ltk.SCA.Update('email', email)
      return
    } else {
      throw new Error("Missing email address or _ltk instance for email capture")
    }
  } catch (e) {
    log("Error capturing email for listrak", e?.message)
  }
}